export function toastSuccess(message) {
    this.$toast.success(message, {
        duration: 1500,
        position: 'top'
    })
}

export function toastError(message) {
    this.$toast.error(message, {
        duration: 1500,
        position: 'top'
    })
}